var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar',{attrs:{"homePage":true}}),_c('div',{directives:[{name:"scroll-spy",rawName:"v-scroll-spy",value:({
     data: 'section',
     time: 500,
     offset: 200
     }),expression:"{\n     data: 'section',\n     time: 500,\n     offset: 200\n     }"},{name:"section-selector",rawName:"v-section-selector",value:('section'),expression:"'section'"}]},[_c('Intro'),_c('WhatIsSCAD'),_c('Symptoms'),_c('CaseStudies'),_c('FAQ'),_c('Test'),_c('ContactUs'),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }